export { MeCab } from './mecab';
export { useMeCabIpaDic } from './use-mecab';
export type { ParsedFeature } from './use-mecab';
